import { render, staticRenderFns } from "./SoftAdminCom.vue?vue&type=template&id=f781512a&"
import script from "./SoftAdminCom.vue?vue&type=script&lang=ts&"
export * from "./SoftAdminCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports